import { Button, TextField } from "@mui/material";
import React, { useState } from "react";
import "./Revise.css";
import "./ReviseProductDescription.css";
import greenIcon from "../assets/ReviseIconGreen.svg";
import { getIdToken } from "../utils/translateHelper";
import axios from "axios";
import {
  PLATFORMS,
  REVISE_PROMT_PRODUCT_DESCRIPTION,
} from "../utils/constants";

const ReviseProductDescription = ({
  GeneratePromtProductDescription,
  productDescriptionContentLocked,
  setIsProductDescriptionLoading,
  setSectionData,
  imagePreview,
  sectionData,
  platform,
}) => {
  const [revisedInfo, setRevisedInfo] = useState("");

  let productPayload;

  if (
    sectionData?.productDescriptionTranslate &&
    Object.keys(sectionData.productDescriptionTranslate).length > 0
  ) {
    productPayload = JSON.parse(sectionData.productDescription);
  } else {
    productPayload = { product_description: sectionData.productDescription };
  }

  const ReviseProductDescription = () => {
    setIsProductDescriptionLoading(true);

    let requestBody = {
      revise_comment: revisedInfo,
      product_description: productPayload,
      image: imagePreview,
      platform,
    };

    getIdToken()
      .then((idToken) => {
        axios
          .post(REVISE_PROMT_PRODUCT_DESCRIPTION, requestBody, {
            headers: { Authorization: idToken },
          })
          .then((response) => {
            let title = "";
            let description = "";
            let bulletPoints = [];

            if (platform === "" || platform === "default") {
              let parsedDescription = response.data?.product_description;

              if (
                typeof parsedDescription === "object" &&
                parsedDescription !== null
              ) {
                if (parsedDescription.hasOwnProperty("Product Description")) {
                  parsedDescription = parsedDescription["Product Description"];
                }
              }

              setSectionData((prevState) => ({
                ...prevState,
                productDescription: parsedDescription,
              }));
            } else {
              let jsonString = response.data.product_description;

              let parsedValue = JSON.parse(jsonString);

              if (typeof parsedValue === "object" && parsedValue !== null) {
                if (parsedValue.hasOwnProperty("Product Description")) {
                  parsedValue = parsedValue["Product Description"];
                }
              }

              if (platform === PLATFORMS.WALMART) {
                title = parsedValue.product_title;
                description = parsedValue.product_description;
                bulletPoints = parsedValue.key_features;
              } else if (platform === PLATFORMS.TARGET) {
                title = parsedValue.title;
                description = parsedValue.details.description;
                bulletPoints = parsedValue.details.highlights;
              } else if (platform === PLATFORMS.AMAZON) {
                title = parsedValue.title;
                description = parsedValue.description;
                bulletPoints =
                  parsedValue.about_this_item || parsedValue["about this item"];
              }

              setSectionData((prevState) => ({
                ...prevState,
                productDescription: jsonString,
                productDescriptionTranslate: {
                  title,
                  description,
                  bulletPoints,
                },
              }));
            }

            setIsProductDescriptionLoading(false);
            setRevisedInfo("");
          })
          .catch((error) => {
            console.log(error);
            setIsProductDescriptionLoading(false);
          });
      })
      .catch((error) => console.log(error));
  };

  return (
    <>
      <div className="flex flex-col items-start w-full">
        <div className="flex flex-col revise-container ">
          <p className="text-label mb-2 revise-container text-black ">
            Ask for revisions
          </p>
          <TextField
            fullWidth
            color="tertiary"
            defaultValue=""
            focused
            value={revisedInfo}
            onChange={(e) => {
              setRevisedInfo(e.target.value);
            }}
            inputProps={{
              sx: {
                height: 12,
              },
            }}
            disabled={productDescriptionContentLocked}
          />
        </div>
        <div className="flex flex-row justify-end w-full">
          <div className="flex flex-wrap justify-center">
            <Button
              sx={{
                fontWeight: 600,
                display: "flex",
                width: "100%",
                maxWidth: "200px",
                height: "45px",
                padding: "8px 10px",
                justifyContent: "center",
                alignItems: "center",
                marginTop: "1rem",
                borderRadius: "6px",
              }}
              className="revise-button-productDescription "
              variant={
                !revisedInfo || productDescriptionContentLocked
                  ? "contained"
                  : "outlined"
              }
              color="secondary"
              onClick={() => {
                ReviseProductDescription();
              }}
              disabled={
                !revisedInfo ||
                productDescriptionContentLocked ||
                imagePreview === null
              }
            >
              <img
                className="flex mr-1.5  h-6 w-6"
                src={
                  !revisedInfo || productDescriptionContentLocked
                    ? require("../assets/reviseIcon.png")
                    : greenIcon
                }
                alt="Revise"
              />
              REVISE
            </Button>
          </div>
        </div>
      </div>

      <div className="regenerate-button">
        <Button
          className="revise-button-productDescription"
          variant="contained"
          color="secondary"
          disabled={productDescriptionContentLocked || imagePreview === null}
          onClick={() => {
            GeneratePromtProductDescription();
          }}
        >
          <img
            className="flex mr-1.5"
            src={require("../assets/regenerateIcon.png")}
            alt="Regenerate"
          />
          REGENERATE
        </Button>
      </div>
    </>
  );
};
export default ReviseProductDescription;
